// SonoSuite bulk upload rule (effective 14 September 2026):
// contributors with a role other than primary / featured / with artist must have
// both a first name and a surname, i.e. the name must contain at least two words.
// NOTE: keep in sync with backexpress/lib/contributor_validation.js

export const FullNameExemptRoles = ["primary", "featuring", "with"];

export function contributorRequiresFullName(type) {
  return !!type && !FullNameExemptRoles.includes(type.trim().toLowerCase());
}

export function hasFullName(name) {
  if (typeof name !== "string") return false;
  return name.trim().split(/\s+/).filter(Boolean).length >= 2;
}

// returns the first contributor (with a role set) whose name is not a full name, or undefined
export function findContributorMissingFullName(contributors, nameKey) {
  return (contributors || []).find(
    (contributor) =>
      contributorRequiresFullName(contributor?.type) &&
      !hasFullName(contributor?.[nameKey])
  );
}

export function fullNameValMessage(type, name) {
  const shownName = name?.trim() ? ` "${name.trim()}"` : "";
  return `Please provide both a first and last name for the ${type}${shownName}. A full name is required for all roles, except primary and featured artists.`;
}
